import React from "react";
import "./bumper-repair.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
export default function BumperRepair() {
  return (
    <>
<Helmet>
  <title>
    Car Bumper Repair & Replacement in Palwal | AutoCare
  </title>

  <meta
    name="description"
    content="Need car bumper repair in Palwal? AutoCare offers affordable bumper dent repair, scratch removal, repainting and bumper replacement with perfect color matching."
  />

  <link
    rel="canonical"
    href="https://car-repair-mechanic-palwal.netlify.app/services/bumper-repair"
  />
</Helmet>

    <section className="servicePage">
      <div className="serviceContent">

        {/* TEXT SECTION */}
        <div className="textContent">
          <h1>Car Bumper Repair Service in Palwal</h1>

          <p>
            A damaged bumper not only affects your car’s appearance but also its safety.
            At <strong>AutoCare</strong>, we offer expert
            <span className="highlight"> bumper repair services</span>
            using modern tools and high-quality materials.
            Trusted <strong>Auto Care in Palwal</strong> for reliable
            <span className="highlight"> car repair</span>.
          </p>

          <h2>What is Bumper Repair?</h2>
          <p>
            Bumper repair is a specialized <span className="highlight">car body repair</span>
            process where cracks, dents, scratches, and broken bumpers are fixed or replaced
            to restore your vehicle’s original look and protection.
          </p>

          <h2>Our Bumper Repair Services Include</h2>
          <ul>
            <li>Cracked bumper repair</li>
            <li>Bumper dent removal</li>
            <li>Scratch removal & repainting</li>
            <li>Bumper replacement (front & rear)</li>
            <li>Accidental bumper damage repair</li>
          </ul>

          <h2>Why Choose AutoCare for Bumper Repair?</h2>
          <ul>
            <li>Skilled technicians with years of experience</li>
            <li>Premium paint & perfect color matching</li>
            <li>Affordable pricing with no hidden charges</li>
            <li>Trusted <span className="highlight">Auto Care in Palwal</span></li>
            <li>Complete <span className="highlight">car repair</span> under one roof</li>
          </ul>

          <h2>Book Bumper Repair Service with AutoCare</h2>
          <p>
            Searching for <span className="highlight">bumper repair near me</span>?
            Choose <strong>AutoCare</strong> for fast, reliable, and professional service.
          </p>
<Link to="/contact" className="primaryBtn">
  Book Bumper Repair Service
</Link>

        
        </div>

        {/* IMAGE SECTION */}
        <div className="imageContent">
          <img
            src="/carServiceImages/bumperrepair.webp"
            alt="Car Bumper Repair Service in Palwal"
          />
        </div>
      </div>
    </section>
    </>
  );
}
